var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 21,
    viewBox: "0 0 58 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40122 15.0223H7.35863L2.48886 8.01793H2.40558V15.0223H0.0386353V3.89331H2.11629L6.95099 10.8933H7.04742V3.89331H9.4056V15.0223H9.40122Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3974 3.89331H24.8157C27.358 3.89331 28.8264 5.45374 28.8264 7.66289C28.8264 9.87204 27.3273 11.4106 24.7543 11.4106H22.7643V15.0179H20.3974V3.89331ZM24.3686 9.53014C25.723 9.53014 26.3849 8.77185 26.3849 7.66727C26.3849 6.5627 25.723 5.82193 24.3555 5.82193H22.76V9.53453H24.3686V9.53014Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9872 3.89331H32.3542V13.0806H37.1538V14.904C37.1538 14.9697 37.1012 15.0179 37.0399 15.0179H29.9916V3.89331H29.9872Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4095 15.0223H45.8716L45.0432 12.4844L44.447 10.6479L43.0707 6.43558H42.9831L41.6067 10.6479H44.447L43.8553 12.4844H41.0062L40.1778 15.0223H37.6399L41.5015 3.89331H44.5522L48.4095 15.0223Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2365 6.63696V14.9914H17.1808V14.1323C16.966 14.3471 16.7205 14.5399 16.44 14.7065C15.8439 15.0615 15.09 15.2412 14.1826 15.2412C13.4594 15.2412 12.8677 15.1273 12.4118 14.9081C11.956 14.6846 11.6009 14.404 11.3467 14.0665C11.0925 13.7246 10.9128 13.3696 10.8032 13.0014C10.6936 12.6332 10.6278 12.2957 10.6059 11.9933C10.584 11.6908 10.5709 11.4673 10.5709 11.327V6.63696H12.9378V10.5819C12.9378 10.7703 12.951 11.0158 12.9729 11.3139C12.9948 11.6119 13.0649 11.91 13.1876 12.208C13.3104 12.5061 13.5032 12.756 13.775 12.9576C14.0468 13.1592 14.4281 13.26 14.9278 13.26C15.125 13.26 15.3442 13.2337 15.5721 13.1767C15.8001 13.1198 16.0148 13.0102 16.2121 12.848C16.4137 12.6858 16.5759 12.4447 16.703 12.1292C16.8301 11.8136 16.8959 11.3972 16.8959 10.8799V6.63696H19.2453H19.2365Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9701 3.89331L53.024 7.54892L54.2469 9.84574L57.6264 3.89331H54.9701Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7457 3.89331H47.0895L51.179 11.0993L48.9436 15.0399H51.2974L53.5591 11.0555L52.3011 8.69295L49.7457 3.89331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuplay);
export default __webpack_public_path__ + "static/media/Nuplay.135f0462f545921b149e5ddb1edcb8a9.svg";
export { ForwardRef as ReactComponent };